var _defs, _rect, _path, _path2, _path3, _path4, _circle, _path5, _rect2, _rect3, _rect4, _circle2, _circle3, _circle4, _circle5, _circle6, _path6, _path7, _path8, _path9, _circle7, _circle8, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatmouseBlack2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #2ba1b3;\n      }\n\n      .cls-3 {\n        fill: #1d1d1b;\n      }\n\n      .cls-4 {\n        fill: #1f509e;\n      }\n\n      .cls-5 {\n        fill: #b3b3b3;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-7 {\n        fill: #f29597;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5,
    y: 10,
    width: 50,
    height: 50,
    rx: 8,
    ry: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.43,11.85c0-5.57-4.52-10.09-10.09-10.09s-10.09,4.52-10.09,10.09c0,.08.01.16.01.25-2.22-.9-4.66-1.41-7.28-1.41s-5.06.5-7.28,1.41c0-.08.01-.16.01-.25,0-5.57-4.52-10.09-10.09-10.09S2.57,6.28,2.57,11.85s4.48,10.05,10.02,10.08c-1.25,2.71-1.95,5.77-1.95,9,0,11.18,12.1,22.08,19.36,22.08s19.36-10.9,19.36-22.08c0-3.24-.7-6.29-1.95-9,5.54-.04,10.02-4.53,10.02-10.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M20.85,12.97c-.24-3.45-3.1-6.17-6.61-6.17s-6.63,2.97-6.63,6.63c0,3.44,2.61,6.26,5.96,6.6,1.77-2.98,4.26-5.42,7.29-7.06Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M52.39,13.44c0-3.66-2.97-6.63-6.63-6.63s-6.37,2.72-6.61,6.17c3.02,1.64,5.52,4.09,7.29,7.06,3.35-.34,5.96-3.16,5.96-6.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M37.14,50.52c-2.51,1.58-5.03,2.5-7.14,2.5s-4.71-.95-7.27-2.58c-.61-.39-.76-8.73,7.27-8.73,6.77,0,7.97,8.29,7.14,8.81Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 30,
    cy: 53.02,
    r: 3.42
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.64,48.34c-4.52-5.95-5.87-12.23-5.87-19.2s2.82-13.27,7.39-17.84S23.03,3.91,30,3.91s13.27,2.82,17.84,7.39,7.39,10.87,7.39,17.84h-3.17s.15-6.86-4.05-12.97c-3.31-4.81-9.78-9.17-18.01-9.17-7.35,0-13.23,3.32-16.65,7.5-5.27,6.45-5.85,14.77-5.85,14.77l-2.13,1.43s-.48,9.25,5.61,17.19c6.09,7.95-.34.45-.34.45"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 48.88,
    y: 17.9,
    width: 7.02,
    height: 17.69,
    rx: 3.47,
    ry: 3.47,
    transform: "translate(108.63 43.97) rotate(170)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.99,
    y: 17.9,
    width: 7.02,
    height: 17.69,
    rx: 3.47,
    ry: 3.47,
    transform: "translate(4.76 -.9) rotate(10)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 10.41,
    y: 47.34,
    width: 4.72,
    height: 6.73,
    rx: 2.33,
    ry: 2.33,
    transform: "translate(-32.11 23.88) rotate(-45)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 30.78,
    cy: 51.95,
    r: 1.57
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 21.12,
    cy: 32.2,
    r: 5.47
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 21.12,
    cy: 32.2,
    r: 4.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 38.5,
    cy: 32.2,
    r: 5.47
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 38.5,
    cy: 32.2,
    r: 4.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.5,48.8c-1.97,1.96-4.4,3.5-6.8,4.88-.03.02-.07,0-.09-.02-.02-.03-.01-.06.01-.08.94-.81,2.16-2.06,3.13-2.81.36-.2,4.28-3.33,3.75-1.97h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.18,49.61c-1.15,2.53-2.89,4.82-4.65,6.96-.02.03-.06.03-.09.01-.03-.02-.03-.05-.02-.08.59-1.09,1.3-2.69,1.94-3.73.27-.32,2.82-4.61,2.82-3.16h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.63,48.44c2.44,1.33,4.6,3.23,6.61,5.13.03.02.03.07,0,.09-.02.02-.06.03-.08.01-1.05-.67-2.59-1.49-3.58-2.2-.3-.3-4.4-3.14-2.95-3.04h0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.06,49.38c1.82,2.1,3.18,4.64,4.39,7.13.02.03,0,.07-.03.09-.03.01-.06,0-.08-.02-.74-.99-1.9-2.31-2.58-3.32-.18-.38-3.02-4.5-1.7-3.88h0Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 39.63,
    cy: 31.85,
    r: 2.26
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 22.27,
    cy: 31.85,
    r: 2.26
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.55,32.76s-2.3-2.86-5.3-3.17c-3-.32-5.57,2.03-5.57,2.03.32-3,3.01-5.18,6.01-4.86s5.18,3.01,4.86,6.01Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M16.5,35.58c.22.34.47.65.75.93.49.49,1.08.89,1.74,1.17s1.37.43,2.13.43,1.47-.15,2.13-.43c.33-.14.64-.31.93-.5s-1.72-.94-3.81-1.38-4.02-.47-3.86-.22Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M43.08,35.58c-.22.34-.47.65-.75.93-.49.49-1.08.89-1.74,1.17s-1.37.43-2.13.43-1.47-.15-2.13-.43c-.33-.14-.64-.31-.93-.5s1.72-.94,3.81-1.38,4.02-.47,3.86-.22Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.41,32.96c-3.47-3.04-6.87-3.76-10.52-.77-.61.2-1.26.3-1.88.25-.61-.04-1.2-.15-1.75-.41-.09-.04-.13-.16-.09-.25.04-.08.13-.12.22-.1,1.03.16,2.15.03,3.09-.42,0,0-.16.1-.16.1.82-.79,1.71-1.41,2.75-1.87,3.18-1.61,7.06.28,8.58,3.29.07.14-.11.28-.22.17h0Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.73,28.75c1.38.89,3.26.67,4.85.58.37-.04.7.24.73.6.04.42-.32.78-.74.73-1.75-.27-3.78-.39-5.08-1.75-.11-.16.12-.31.24-.16h0Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.07,32.76s2.3-2.86,5.3-3.17c3-.32,5.57,2.03,5.57,2.03-.32-3-3.01-5.18-6.01-4.86s-5.18,3.01-4.86,6.01Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.99,32.79c1.53-3.01,5.4-4.9,8.58-3.29,1.04.46,1.94,1.07,2.75,1.87l-.16-.1c.93.45,2.05.58,3.09.42.11-.02.22.05.23.16.01.08-.03.16-.11.2-.56.26-1.14.38-1.75.41-.57.03-1.5-.03-1.99-.34-3.64-2.91-7-2.13-10.41.86-.11.11-.3-.04-.22-.17h0Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.13,28.91c-1.3,1.36-3.33,1.48-5.08,1.75-.37.04-.7-.22-.74-.59-.05-.42.31-.78.73-.74,1.59.09,3.51.33,4.89-.61.12-.11.3.06.2.19h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatmouseBlack2);
export default __webpack_public_path__ + "static/media/chatmouse_Black2.57b157225f056af260825027f1188d93.svg";
export { ForwardRef as ReactComponent };